import { render, staticRenderFns } from "./listMenus.vue?vue&type=template&id=0a5b4c26&"
import script from "./listMenus.vue?vue&type=script&lang=js&"
export * from "./listMenus.vue?vue&type=script&lang=js&"
import style0 from "./listMenus.vue?vue&type=style&index=0&script=css&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports